module.exports = __webpack_public_path__ + "resources/incoming-video-call-37a9f84949f9b8819d9b8f5b07389fba.svg";